import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const getParentOrigin = (): string => {
  try {
    return document.referrer
      ? new URL(document.referrer).origin
      : window.location.origin
  } catch {
    return window.location.origin
  }
}

export const getParentUrlParam = (param: string): string | null => {
  try {
    const parentUrl = new URL(window.parent.location.href)
    return parentUrl.searchParams.get(param)
  } catch {
    try {
      const referrerUrl = new URL(document.referrer)
      return referrerUrl.searchParams.get(param)
    } catch {
      return null
    }
  }
}

export const formatDate = (ts: number | null): string => {
  if (!ts) return ''
  return dayjs(ts).format('YYYY-MM-DD')
}

export const formatDateFull = (ts: number | null): string => {
  if (!ts) return ''
  return dayjs(ts).format('YYYY-MM-DD hh:mma')
}

export const formatDateInput = (ts: number | null): string => {
  if (!ts) return ''
  return dayjs(ts).format('YYYY-MM-DD')
}

export const codesToRecord = (
  codes: (string | number)[]
): Record<string, string> => {
  const obj: Record<string, string> = {}
  codes.forEach((code) => {
    obj[String(code)] = 'on'
  })
  return obj
}

export { getIframeVisibleCenter } from '../../common/utils/iframe'
